const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const onDownload = (_link: any, appFrom?: string) => {
  if (_link) {
    const a = document.createElement('a');
    a.href =
      appFrom && appFrom === 'mygov.uz' ? _link : BASE_URL + '/api/v1/admin/media/file/' + _link;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
};

export const capitalizeFirstLowercaseRest = (str: string | undefined) => {
  if (str) return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
